@if (plan) {
  <div class="plan--enroll">
    @if (config) {
      <model-attribute
        [config]="config"
        direction="row_equal"
        data-test-id="planAttributes"
      >
      </model-attribute>
    }
    @if (showEnrollButton) {
      <zip-button
        (zipButtonClicked)="enroll.emit(plan)"
        [disabled]="disableEnrollButton"
        [level]="buttonConfig.level"
        [config]="buttonConfig"
        [content]="buttonConfig.content"
        data-test-id="PlanEnrollButton"
      >
      </zip-button>
    }
  </div>
}
